// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81401b53","501":"5cf49e32","925":"0bcaf5ad"}[chunkId] + ".chunk.js";
};